import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    Popover,
    PopoverContent,
    PopoverTrigger,
    Skeleton,
} from '@repo/shadcn';
import { ChevronsUpDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useController } from 'react-hook-form';

import {
    API_LIMIT,
    API_PAGE,
    API_SORT_BY,
    API_SORT_ORDER,
} from '../../../../../constants/api-query-params.constant';
import { useGetBrandsQuery } from '../../../../../features/slice/products/brand/brand-api-slice';

export function BrandsAutoComplete({ control, name }: any) {
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: searchData, isLoading } = useGetBrandsQuery({
        limit: API_LIMIT.DEFAULT_LIMIT,
        page: API_PAGE.DEFAULT_PAGE,
        search: debouncedSearchTerm || undefined,
        sort_order: API_SORT_ORDER.ASCENDING,
        sort_by: API_SORT_BY.NAME,
    });

    const handleSearchInput = (value: string) => {
        setSearchTerm(value);
    };

    const { field } = useController({ name, control });

    const selectedBrand = searchData?.data.find(
        (brand: any) => brand.id === field.value,
    );

    if (isLoading) {
        return <Skeleton className="mt-2 h-[40px] w-full" />;
    }

    return (
        <div id="portal-root">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        role="combobox"
                        aria-expanded={open}
                        className="w-full justify-between   truncate"
                    >
                        <p className="w-[90%] truncate duration-300">
                            {selectedBrand
                                ? selectedBrand.name
                                : 'Select brand...'}
                        </p>
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                </PopoverTrigger>
                <PopoverContent>
                    <Command className="relative w-[280px]">
                        <CommandInput
                            value={searchTerm}
                            onValueChange={handleSearchInput}
                            placeholder="Search brand..."
                            className="truncate"
                        />
                        <CommandList>
                            <CommandEmpty>No brand found.</CommandEmpty>
                            <CommandGroup>
                                {searchData?.data?.map((brand: any) => (
                                    <CommandItem
                                        key={brand.id}
                                        value={brand.name}
                                        onSelect={() => {
                                            field.onChange(brand.id);
                                            setOpen(false);
                                        }}
                                        className="border-b-[1px]"
                                    >
                                        {brand.name}
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    );
}
